import { render, staticRenderFns } from "./PcSelect.vue?vue&type=template&id=475da40f&scoped=true&"
import script from "./PcSelect.vue?vue&type=script&lang=js&"
export * from "./PcSelect.vue?vue&type=script&lang=js&"
import style0 from "./PcSelect.vue?vue&type=style&index=0&id=475da40f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475da40f",
  null
  
)

export default component.exports